import React from "react";
import s from "../icons/s.jpg";
import d from "../icons/d.jpg";
import t from "../icons/t.jpg";
import a from "../icons/a.jpg";
import b from "../icons/b.jpg";
import m from "../icons/m.jpg";
import "../styles/Teammate.css";
import { useTranslation } from "react-i18next";

const Teammate = () => {
  // Named translate: "t" is already the imported photo t.jpg below.
  const { t: translate } = useTranslation();
  // const [contextLang,setContextLang]=useLang();
  // const { t, i18n } = useTranslation();
  // const [lang, setLang] = useLocalStorage("lang");

  // const changeLang = () => {
  //   const newLang = lang === "tr" ? "en" : "tr";
  //   setLang(newLang);
  //   setContextLang(newLang);
  //   i18n.changeLanguage(newLang);
  // };

  const LinkedinIcon = ({ size = "2em"}) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 128 128"
      aria-hidden="true"
    >
      <path
        fill="#0076b2"
        d="M116 3H12a8.91 8.91 0 0 0-9 8.8v104.42a8.91 8.91 0 0 0 9 8.78h104a8.93 8.93 0 0 0 9-8.81V11.77A8.93 8.93 0 0 0 116 3"
      />
      <path
        fill="#fff"
        d="M21.06 48.73h18.11V107H21.06zm9.06-29a10.5 10.5 0 1 1-10.5 10.49a10.5 10.5 0 0 1 10.5-10.49m20.41 29h17.36v8h.24c2.42-4.58 8.32-9.41 17.13-9.41C103.6 47.28 107 59.35 107 75v32H88.89V78.65c0-6.75-.12-15.44-9.41-15.44s-10.87 7.36-10.87 15V107H50.53z"
      />
    </svg>
  );


  const LinkedInLink = ({ url, size }) => {
    return (
      <a
        className="linkedin"
        href={url}
        aria-label={translate("linkedinProfile")}
        target="_blank"
        rel="noopener noreferrer" // Reverse tabnabbing engelle, referrer header info engelle
      >
        <LinkedinIcon size={size} />
      </a>
    );
  };

  const TeamMember = ({
    image,
    name,
    role,
    linkedinUrl,
    iconSize = "2em"
  }) => {
    return (
      <div className="image-item-teammate">
        <div className="deneme">
          <img src={image} alt={name + " " + role} />
        </div>
        <div className="text-item">
          <p className="team-item">{name}</p>
          <p className="item-team">{role}</p>
          <LinkedInLink url={linkedinUrl} size={iconSize} />
        </div>
      </div>
    );
  }

  return (
    <section id="teammate">
      <div style={{ backgroundColor: "#ffb923", padding: "3rem" }}>
        <div id="emptyDiv"></div>
        <h2 className="header-item-teammate">{translate("team")}</h2>

        <div className="founders-row">
          <TeamMember image={s} name="Semih Birincioğlu" role="Co-Founder" linkedinUrl="https://www.linkedin.com/in/semih-birincio%C4%9Flu-22528891/" />

          <TeamMember image={d} name="Hüseyin Doruk Tunca" role="Co-Founder" linkedinUrl="https://tr.linkedin.com/in/h%C3%BCseyin-doruk-tunca-7a03ba83" />
        </div>
          
        <div className="team-row">
          <TeamMember image={a} name="Alperen Akgün" role="Software Engineer" linkedinUrl="https://tr.linkedin.com/in/alperen-akgn" />

          <TeamMember image={t} name="Süleyman Tunahan Ateş" role="Software Engineer" linkedinUrl="https://www.linkedin.com/in/tuna-ats/" />

          <TeamMember image={b} name="Burakhan Katdar" role="IT Business Analyst" linkedinUrl="https://www.linkedin.com/in/burakhankatdar/" />

          <TeamMember image={m} name="Mehmet Ali Ertörer" role="Software Engineer" linkedinUrl="https://www.linkedin.com/in/mehmetaliertorer/" /> 
        </div>

       
          
      </div>
    </section>
  );
};

export default Teammate;